module.exports = __webpack_public_path__ + "static/media/rosaparks-mural-xonly.77e4b0b9.png";